import React, { useState, useEffect, useContext } from 'react';
// import clsx from 'clsx';
// import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import {
  List,
  ListItem,
  ListItemText,
  Collapse,
  IconButton,
  Grid 

} from '@material-ui/core';

import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';

import {
  Day,
} from '../';

import _ from 'lodash';

import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import AddIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import RemoveIcon from '@material-ui/icons/RemoveCircleOutlineOutlined';

import { format } from 'date-fns';
import config from '../../../../config/config.json'
import OrderContext from '../../../../context/orderContext'
import withAlert from '../../../../hoc/withAlert'

const useStyles = makeStyles(theme => ({
  paper: {
    display: 'flex',
    border: `1px solid ${theme.palette.divider}`,
    flexWrap: 'wrap',
  },
  divider: {
    alignSelf: 'stretch',
    height: 'auto',
    margin: theme.spacing(1, 0.5),
  },
}));

const StyledToggleButtonGroup = withStyles(theme => ({
  grouped: {
    margin: theme.spacing(0.5),
    border: 'none',
    padding: theme.spacing(0, 1),
    '&:not(:first-child)': {
      borderRadius: theme.shape.borderRadius,
    },
    '&:first-child': {
      borderRadius: theme.shape.borderRadius,
    },
  },
}))(ToggleButtonGroup);


const Session = props => {
  const orderContext = useContext(OrderContext);
  // Заберем из HOC нужные методы для показа алерта
  const {setSnackMessage, setSnackType, setOpenSnack} = props

  // console.log('orderContext',orderContext.actionType);
  const {  session, mealsTypes} = props;
  const { id, name, days } = session
  const classes = useStyles();

// Состояние открыт закырт
  const [open, setOpen] = useState(false);
// Состояение для кнопки включить выключить завтраки обеды ужины
  const [mealTypeChecked, setmealTypeChecked] = useState({});
  // Состояние для включить выключить выходные
  const [weekendChecked, setEeekendChecked] = useState(true);

  // Состояение всех чекбоксов
  const [checked, setChecked] = useState(
    props.checked
   )

  //  Обработчик свертывания развертывания
  const handleClick = () => {
    setOpen(!open);
  };

  // Состояние при старте
  useEffect(() => {
    // console.log('useEffect', props.session.open)
    // setOpen(props.session.open);
  
    // Состояние для кнопок завтраки обеды ужины
    const mealTypeCheckedDefault = _.reduce(mealsTypes , function(obj, m) {
      obj[m.id] = false
      return obj;
     }, {})
  
    // console.log('Session mealTypeCheckedDefault',name, mealTypeCheckedDefault)
    setmealTypeChecked(mealTypeCheckedDefault);
    
  }, []);

  // Изменения состояния при изменении стейта из вне
  useEffect(() => {
  
    setChecked(props.checked)

  }, [props.checked]);

  
  const handleCheckedOne = (dayChecked) => {
      props.onCheckedOne({[id]: _.assign(checked, dayChecked) })
  }

  const [batchActions, setBatchActions] = React.useState(() => []);
  const [batchActionsPeriod, setBatchActionsPeriod] = React.useState(() => 1);

  const handleBatchActions = (event, newFormats) => {
    setBatchActions(newFormats);
  };

  const handleBatchActionsPeriod = (event, newFormats) => {
    setBatchActionsPeriod(newFormats);
  };




  const batchChangeFilterDate = (day) => {
    const isWeekend = _.filter(days, (d) => {
      return d.date === day;
    })[0].weekend

    const today = new Date()
    const tomorrow = new Date(today)
    tomorrow.setDate(tomorrow.getDate() + 1)

    switch (batchActionsPeriod) {
      case 1:
        return true
      case 2:
        return isWeekend ? false : true
      case 3:
        return isWeekend ? true : false
      case 4:
        return format(tomorrow,'dd.MM.yyyy') === day ? true : false
      
    }
  }

  const handleBatchChange = (callback) => {
    if (batchActions.length === 0){
      setSnackMessage('Не выбран тип питания')
      setSnackType('error')
      setOpenSnack(true)
      return
    }
    if (batchActionsPeriod === null){
      setSnackType('error')
      setSnackMessage('Не выбран период')
      setOpenSnack(true)
      return
    }
    // console.log('handleAdd',batchActions,batchActionsPeriod)

    // console.log('checked',checked);

    const checkedNew =  _.reduce({ ...checked} , function(obj, dayValue, dayDate) {
      // Обработаем варианты фильтрации дат
      // Получим признак выходного

      obj[dayDate] = batchChangeFilterDate(dayDate) ?
      _.reduce({ ...dayValue} , function(mObj, mValue, mIndex) {
        if(batchActions.indexOf(parseInt(mIndex)) !== -1 ){
          mObj[mIndex] = callback(mValue)
        }
        else{
          mObj[mIndex] = mValue
        }
        return mObj;
       }, {}) : dayValue
      
      return obj;
     }, {})
  
    //  console.log('checkedNew',checkedNew);
     setChecked(checkedNew)
     props.onCheckedOne({[id]: checkedNew })

  }


  const handleAdd = () => {
    const incr = (x) => {return ++x} 
    handleBatchChange(incr)
  }

  const handleMinus = () => {
    const decr = (x) => {return x > 0 ? --x : 0} 
    handleBatchChange(decr)

  }

  return (
    <React.Fragment>

    <List
      component="nav"
      aria-labelledby="nested-list-subheader"
      className={classes.root}
      dense={false}
    >
      <ListItem button onClick={handleClick}>
        {open ? <ExpandLess /> : <ExpandMore />}
        <ListItemText primary={name} />

        {/* <ListItemSecondaryAction>
          

        </ListItemSecondaryAction> */}

      </ListItem>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding dense={false}>
        {/* <ListItem role={undefined} dense 
                // button 
                // onClick={handleChange(m.id)}
                >

<Grid
  container
  direction="row"
  justify="flex-start"
  alignItems="center"
>
        <Grid
          item
          xs={4}
        >
          <IconButton aria-label="add"  onClick={handleAdd} disabled={orderContext.actionType === 'edit'}>
            <AddIcon fontSize="small" />
          </IconButton>

          <IconButton aria-label="add"  onClick={handleMinus} disabled={orderContext.actionType === 'edit'}>
            <RemoveIcon fontSize="small" />
          </IconButton>
        </Grid>

        <Grid
          item
          xs={8}
        >

<Grid
  container
  direction="column"
  justify="flex-start"
  alignItems="flex-start"
  spacing={1}

>
          <Grid
          item
          xs={12}>
          <ToggleButtonGroup aria-label="text formatting" size="small" value={batchActions} onChange={handleBatchActions}>
            <ToggleButton value={_.filter(config.mealsTypes,['name','Завтрак'])[0].id} aria-label="bold">
              Зaвтраки
            </ToggleButton>
            <ToggleButton value={_.filter(config.mealsTypes,['name','Обед'])[0].id} aria-label="italic">
              Обеды
            </ToggleButton>
            <ToggleButton value={_.filter(config.mealsTypes,['name','Ужин'])[0].id} aria-label="underlined">
              Ужины
            </ToggleButton>
          </ToggleButtonGroup>

          </Grid>

          <Grid
          item
          xs={12}>
          <ToggleButtonGroup aria-label="text formatting" size="small" value={batchActionsPeriod} exclusive onChange={handleBatchActionsPeriod}>
            <ToggleButton value={1} aria-label="bold">
              Все
            </ToggleButton>
            <ToggleButton value={2} aria-label="italic">
              Без_вых
            </ToggleButton>
            <ToggleButton value={3} aria-label="underlined">
              Вых
            </ToggleButton>
            <ToggleButton value={4} aria-label="underlined">
              Зав
            </ToggleButton>

          </ToggleButtonGroup> 
          </Grid>

  </Grid>



        </Grid>

</Grid>

      </ListItem> */}

          {
            days.map((d, index) => (
              <Day
                key={d.date}
                day={d}
                checked={checked[d.date]}
                onCheckedOne={handleCheckedOne}
                sessionId={id}
              />
            )
            )}

        </List>

      </Collapse>

    </List>
    </React.Fragment>
  );
};


export default withAlert(Session);
